import Fetcher from 'utils/fetcher';

const api = new Fetcher();
const apiUrl = process.env.REACT_APP_BACKEND_API;

export const getConfiguration = async () => api.get(`${apiUrl}/booking/getpromericauridfpi`);
